import { useMutation, useQuery } from '@apollo/client/react';
import { Button, Descriptions, Form, Input, message, Modal, Spin, Tag, Typography } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { Spacer } from '../../components/Spacer';
import { ADMIN_BLOCK_USER, ADMIN_USER } from '../../gqls/users';

export const PageUser = () => {
  const params = useParams();

  const [messageApi, contextHolder] = message.useMessage();

  const [blockModalVisible, setBlockModalVisible] = useState(false);
  const [blockMessage, setBlockMessage] = useState('');

  const { data, loading } = useQuery(ADMIN_USER, { variables: { where: { id: params.id } } });

  const [adminBlockUser, { loading: adminBlockUserLoading }] = useMutation(ADMIN_BLOCK_USER);

  const user = data?.adminUser;

  const handleUnBlock = () => {
    if (window.confirm('Разблокировать пользователя?')) {
      adminBlockUser({ variables: { where: { id: user.id }, data: { message: '' } } })
        .then(() => {
          messageApi.success('Пользователь разблокирован');
        })
        .catch((err) => {
          console.error(err);
          messageApi.error('Произошла ошибка, попробуйте еще раз');
        });
    }
  };

  return (
    <>
      {contextHolder}
      <Typography.Title level={5} style={{ margin: 0 }}>
        Пользователь
      </Typography.Title>
      <Spacer h={12} />
      {loading ? (
        <Spin />
      ) : user ? (
        <>
          {user.avatar ? (
            <>
              <img src={user.avatar} alt="avatar" style={{ maxWidth: 120 }} />
              <Spacer h={20} />
            </>
          ) : null}
          <Descriptions
            layout="vertical"
            bordered
            items={[
              {
                key: 'id',
                label: 'ID',
                children: user.id,
              },
              {
                key: 'createdAt',
                label: 'Создан',
                children: dayjs(user.createdAt).format('DD.MM.YYYY HH:mm'),
              },
              {
                key: 'name',
                label: 'Имя',
                children: user.name,
              },
              {
                key: 'phone',
                label: 'Номер телефона',
                children: user.phone,
              },
              {
                key: 'allowPermissionLocation',
                label: 'Разрешение на геолокацию',
                children: user.allowPermissionLocation ? 'Да' : 'Нет',
              },
              {
                key: 'allowPermissionNotification',
                label: 'Разрешение на уведомления',
                children: user.allowPermissionNotification ? 'Да' : 'Нет',
              },
              {
                key: 'blocked',
                label: 'Статус',
                children: user.blocked ? <Tag color="red">Заблокирован</Tag> : <Tag color="green">Активен</Tag>,
              },
            ]}
          />
          <Spacer h={16} />
          {user.blocked ? (
            <Button onClick={handleUnBlock} type="primary">
              Разблокировать
            </Button>
          ) : (
            <Button onClick={() => setBlockModalVisible(true)} danger>
              Заблокировать
            </Button>
          )}
          <Modal
            open={blockModalVisible}
            onCancel={() => setBlockModalVisible(false)}
            title="Заблокировать пользователя"
            footer={
              <>
                <Button type="default" onClick={() => setBlockModalVisible(false)}>
                  Отмена
                </Button>
                <Button
                  type="primary"
                  loading={adminBlockUserLoading}
                  disabled={!blockMessage}
                  onClick={() => {
                    adminBlockUser({ variables: { where: { id: user.id }, data: { message: blockMessage } } })
                      .then(() => {
                        messageApi.success('Пользователь заблокирован');
                      })
                      .catch((err) => {
                        console.error(err);
                        messageApi.error('Произошла ошибка, попробуйте еще раз');
                      })
                      .finally(() => setBlockModalVisible(false));
                  }}
                  danger
                >
                  Заблокировать
                </Button>
              </>
            }
          >
            <Form.Item label="Причина" required layout="vertical">
              <Input value={blockMessage} onChange={(e) => setBlockMessage(e.target.value)} style={{ width: '100%' }} />
            </Form.Item>
          </Modal>
        </>
      ) : null}
    </>
  );
};
